import React from 'react';

/**
 * 统一加载组件
 * 用于 Suspense fallback 和异步加载状态
 */
const Loading = ({ message = '加载中...' }) => (
  <div className="dashboard-loading">
    <div className="spinner"></div>
    {message && (
      <p style={{ 
        marginTop: '12px', 
        color: 'var(--t2)',
        fontSize: '13px'
      }}>
        {message}
      </p>
    )}
  </div>
);

export default Loading;
